import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';

import { ServicefinService } from '../services/servicefin.service';
import { ReponseWebService } from '../datastruct/Meloyi.module';


@Component({
  selector: 'app-detailops',
  templateUrl: './detailops.component.html',
  styleUrls: ['./detailops.component.css']
})
export class DetailopsComponent implements OnInit {

	infosOp : any ;

	samacaabiyoonwii : any ;

	caisseEtProvider : any ; //{caisse:"Mahfouz Aidara", provider:"Abdoul Hamid Diallo" } ;


	retourClientWS  : ReponseWebService ;


	constructor(private configServer: ServicefinService, public dialogRef: MatDialogRef<DetailopsComponent>, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) {
		this.infosOp = data.opt ;
		console.log(this.infosOp) ;
	}

	ngOnInit(): void {
	    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;
	    this.getThese(this.infosOp.iduser, this.infosOp.idinit) ;
	}


	openDialog() {
		this.dialog.open(DialogChequeScanDialog, {
		  data: {
		    src: this.infosOp.asset
		  }
		});
	}


   getThese(caisse, provider){

	    this.configServer.infosUsers(this.samacaabiyoonwii, caisse, provider).then( (retourbi) => {
	      this.retourClientWS = retourbi ;
	      var statutrec = this.retourClientWS.statutreq ;
	      console.log(retourbi) ;
	      
	      if(statutrec==1){
	        this.caisseEtProvider = this.retourClientWS.data ; 
	      }
	      else
	        console.log("Failed") ;
	    }) ;    

   }


  	getProvider(){  		
  		return this.caisseEtProvider.provider ;
  	}

  	getCaisse(){
  		return this.caisseEtProvider.caisse ;
  	}

  	getCompagnie(){
  		console.log(JSON.parse(this.infosOp.infosup).compagnie) ;		
  		return JSON.parse(this.infosOp.infosup).compagnie.nomcompagnie ;
  	}

  	getMotif(){
  		return JSON.parse(this.infosOp.infosup).motif ;
  	}

  	getPeriodeVersDeb(){
  		return this.infosOp.debperiode ;
  	}

  	getPeriodeVersFin(){
  		return this.infosOp.finperiode ;
  	}


	getMontantFormatee(montant){
		let resultd = Number(montant).toLocaleString('fr-FR');
		return resultd ;
	}

}




@Component({
  selector: 'dialog-cheque-scan-dialog',
  templateUrl: 'dialog-cheque-scan-dialog.html',
})
export class DialogChequeScanDialog {
   linkScan  : any ;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
  	this.linkScan = data.src ;
  }
}
